import { Router } from "express";
import { db } from "@workspace/db";
import { usersTable, companiesTable } from "@workspace/db";
import { eq } from "drizzle-orm";
import { jitProvisionUser, requireAuth, requireAdmin, type AuthRequest } from "../lib/auth";

const router = Router();

router.get("/users/me", jitProvisionUser, async (req: AuthRequest, res, next) => {
  try {
    res.json(req.dbUser);
  } catch (err) {
    next(err);
  }
});

router.patch("/users/me", requireAuth, async (req: AuthRequest, res, next) => {
  try {
    const { firstName, lastName, language } = req.body;
    const updated = await db
      .update(usersTable)
      .set({
        ...(firstName !== undefined && { firstName }),
        ...(lastName !== undefined && { lastName }),
        ...(language !== undefined && { language }),
        updatedAt: new Date(),
      })
      .where(eq(usersTable.id, req.dbUser!.id))
      .returning();
    res.json(updated[0]);
  } catch (err) {
    next(err);
  }
});

// Admin routes
router.get("/admin/users", requireAdmin, async (req: AuthRequest, res, next) => {
  try {
    const users = await db.select().from(usersTable);
    res.json(users);
  } catch (err) {
    next(err);
  }
});

router.patch("/admin/users/:userId", requireAdmin, async (req: AuthRequest, res, next) => {
  try {
    const { userId } = req.params;
    const { role, isSuspended } = req.body;
    const updated = await db
      .update(usersTable)
      .set({
        ...(role !== undefined && { role }),
        ...(isSuspended !== undefined && { isSuspended }),
        updatedAt: new Date(),
      })
      .where(eq(usersTable.id, Number(userId)))
      .returning();
    if (!updated[0]) return res.status(404).json({ error: "User not found" });
    res.json(updated[0]);
  } catch (err) {
    next(err);
  }
});

export default router;
